module.exports = __webpack_public_path__ + "static/media/landing-image.0bfb5f09.jpg";